// import {
//   Check,
//   ChevronDown,
//   CreditCard,
//   Package,
//   Store,
//   Truck,
//   Wallet,
//   X,
// } from "lucide-react";
// import { useTranslation } from "react-i18next";
// import { useForm } from "react-hook-form";
// import { useCart } from "@/contexts/CartProvider";
// import mealPlaceholder from "@/assets/meal-placeholder.png";

// export default function checkoutScreen() {
//   const { t } = useTranslation();

//   const { cartItems, totalPrice } = useCart();

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     watch,
//   } = useForm();

//   const onSubmit = (data: any) => {
//     console.log(data);
//   };

//   const paymentMethods = [
//     {
//       id: "visa",
//       name: t("payment.credit_card"),
//       icon: CreditCard,
//       description: t("payment.credit_card_desc"),
//     },
//     {
//       id: "cash",
//       name: t("payment.cash"),
//       icon: Wallet,
//       description: t("payment.cash_desc"),
//     },
//   ];

//   const orderTypes: any[] = [
//     {
//       id: "dine-in",
//       name: t("order.dine_in") || "Dine In",
//       icon: Store,
//       description: t("order.dine_in_desc") || "Eat at the restaurant",
//       color: "blue",
//     },
//     {
//       id: "pickup",
//       name: t("order.pickup") || "Pickup",
//       icon: Package,
//       description: t("order.pickup_desc") || "Pick up your order",
//       color: "blue",
//     },
//     {
//       id: "delivery",
//       name: t("order.delivery") || "Delivery",
//       icon: Truck,
//       description: t("order.delivery_desc") || "Deliver to your address",
//       color: "blue",
//     },
//   ];

//   const getColorClasses = (color: string) => {
//     const colors = {
//       blue: "text-blue-600 bg-blue-50 border-blue-200",
//       indigo: "text-indigo-600 bg-indigo-50 border-indigo-200",
//       gray: "text-gray-600 bg-gray-50 border-gray-200",
//       green: "text-green-600 bg-green-50 border-green-200",
//     };
//     return color in colors ? colors[color as keyof typeof colors] : colors.blue;
//   };

//   return (
//     <div className="h-full flex lg:p-16 flex-col lg:flex-row gap-8">
//       <div className="bg-gray-50 border border-gray-200 p-2 lg:p-6 flex-1">
//         <form
//           onSubmit={handleSubmit(onSubmit)}
//           className="h-full flex flex-col"
//         >
//           <div className="flex-1 overflow-y-auto flex flex-col gap-4">
//             <h1 className="text-2xl font-bold mb-4 text-center">Checkout</h1>
//             <div
//               className={`rounded-xl p-6 shadow-sm ${
//                 errors.orderType
//                   ? "border border-red-500 bg-red-50"
//                   : "bg-white border border-gray-200"
//               }`}
//             >
//               <h3 className="text-lg font-semibold text-gray-900 mb-6 flex items-center">
//                 {"Order Type"}
//               </h3>

//               <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
//                 {orderTypes.map((orderType: any) => {
//                   const selected = watch("orderType") === orderType.id;
//                   return (
//                     <label
//                       key={orderType.id}
//                       className={`p-4 border-2 rounded-xl transition-all duration-200 text-start ${
//                         selected
//                           ? `border-primary bg-primary-light`
//                           : " border-gray-200 hover:border-gray-300 bg-white"
//                       }`}
//                     >
//                       <input
//                         type="radio"
//                         value={orderType.id}
//                         {...register("orderType", {
//                           required: "please select an order type",
//                         })}
//                         className="hidden"
//                       />
//                       <div className="flex items-center mb-2">
//                         <div
//                           className={`p-2 rounded-lg me-3 bg-primary-light text-primary`}
//                         >
//                           <orderType.icon className="w-5 h-5" />
//                         </div>
//                         <div className="flex-1">
//                           <div className="font-semibold text-gray-900 text-start">
//                             {orderType.name}
//                           </div>
//                         </div>
//                         {selected && (
//                           <Check className={`w-5 h-5 text-primary`} />
//                         )}
//                       </div>
//                       <div className="text-sm text-gray-500">
//                         {orderType.description}
//                       </div>
//                     </label>
//                   );
//                 })}
//               </div>
//               <p className="text-red-500">
//                 {errors.orderType && (
//                   <p className="text-red-500">
//                     {errors.orderType.message as string}
//                   </p>
//                 )}
//               </p>
//             </div>

//             <div
//               className={`rounded-xl p-6 shadow-sm  ${
//                 errors.paymentMethod
//                   ? "border border-red-500 bg-red-50"
//                   : "bg-white border border-gray-200"
//               }`}
//             >
//               <h3 className="text-lg font-semibold text-gray-900 mb-6 flex items-center">
//                 {"Payment Method"}
//               </h3>

//               <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
//                 {paymentMethods.map((paymentMethod: any) => {
//                   const selected = watch("paymentMethod") === paymentMethod.id;
//                   return (
//                     <label
//                       key={paymentMethod.id}
//                       className={`p-4 border-2 rounded-xl transition-all duration-200 text-start ${
//                         selected
//                           ? `border-primary bg-primary-light`
//                           : " border-gray-200 hover:border-gray-300 bg-white"
//                       }`}
//                     >
//                       <input
//                         type="radio"
//                         value={paymentMethod.id}
//                         {...register("paymentMethod", {
//                           required: "plase select a payment method",
//                         })}
//                         className="hidden"
//                       />
//                       <div className="flex items-center mb-2">
//                         <div className="p-2 rounded-lg me-3 bg-primary-light text-primary">
//                           <paymentMethod.icon className="w-5 h-5" />
//                         </div>
//                         <div className="flex-1">
//                           <div className="font-semibold text-gray-900 text-start">
//                             {paymentMethod.name}
//                           </div>
//                         </div>
//                         {selected && <Check className="w-5 h-5 text-primary" />}
//                       </div>
//                       <div className="text-sm text-gray-500">
//                         {paymentMethod.description}
//                       </div>
//                     </label>
//                   );
//                 })}
//               </div>
//               <p className="text-red-500">
//                 {errors.paymentMethod && (
//                   <p className="text-red-500">
//                     {errors.paymentMethod.message as string}
//                   </p>
//                 )}
//               </p>
//             </div>

//             <button
//               type="submit"
//               disabled={false}
//               className="cursor-pointer mt-auto w-full bg-primary disabled:from-gray-400 disabled:to-gray-500 text-white font-bold py-4 px-6 rounded-xl transition-all duration-200 transform hover:bg-primary/90 shadow-lg flex items-center justify-center text-lg"
//             >
//               Complete
//             </button>
//           </div>
//         </form>
//       </div>
//       <div className="flex-1 flex flex-col gap-4">
//         <div className="bg-white rounded-xl p-8 flex flex-col gap-4 border border-gray-200 shadow-sm">
//           <div className="flex flex-row items-center">
//             <h1 className="text-2xl font-bold">Summary</h1>
//             <p className="bg-primary ms-auto p-2 text-white font-semibold rounded-xl">
//               {cartItems.length} items
//             </p>
//           </div>
//           <div className="flex flex-col gap-4">
//             {cartItems.map((cartItem, index) => (
//               <div className="flex flex-row gap-4 items-center">
//                 <span className="bg-primary rounded-full h-8 w-8 flex items-center justify-center text-white font-semibold">
//                   {cartItem.quantity}
//                 </span>
//                 <span className="text-xl">×</span>
//                 <img
//                   src={cartItem.item.image || mealPlaceholder}
//                   className="w-16 h-16 object-cover"
//                 />
//                 <div className="flex flex-col">
//                   <h1>{cartItem.item.name}</h1>
//                   <p className="text-gray-500 text-xs">
//                     {cartItem.ingredients
//                       .map((ingredient) => ingredient.name)
//                       .join(", ")}
//                   </p>
//                 </div>
//                 <span className="text-primary font-semibold ms-auto">
//                   ₪
//                   {(cartItem.item.price +
//                     cartItem.ingredients.reduce(
//                       (acc, ing) => acc + ing.price,
//                       0
//                     )) *
//                     cartItem.quantity}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>
//         <div className="bg-white rounded-xl p-8 flex flex-row border border-gray-200 shadow-sm items-center">
//           <h1 className="text-2xl font-bold">Total</h1>
//           <span className="bg-primary font-semibold ms-auto text-white rounded-xl p-2">
//             ₪{totalPrice}
//           </span>
//         </div>
//       </div>
//     </div>
//   );
// }

import {
  Check,
  CreditCard,
  Loader2,
  Package,
  Store,
  Truck,
  Wallet,
  X,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useCart } from "@/contexts/CartProvider";
import mealPlaceholder from "@/assets/meal-placeholder.png";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import VisaPaymentForm from "@/components/VisaPaymentForm";
import toast from "react-hot-toast";
import { useAuth } from "@/contexts/AuthProvider";

export default function checkoutScreen() {
  const { t } = useTranslation();

  const { cartItems, totalPrice } = useCart();

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [paymentFailed, setPaymentFailed] = useState(false);
  const { deleteActiveCart } = useCart();

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();
  const [paymentUrl, setPaymentUrl] = useState<string | null>(null);
  const { token, customerId } = useAuth();

  useEffect(() => {
    if (paymentUrl) {
      function handleMessage(event: MessageEvent) {
        console.log("Received message from iframe:", event.data);
      }
      window.addEventListener("message", handleMessage);
    }
  }, [paymentUrl]);

  const onCheckoutSuccess = () => {
    setPaymentUrl(null);
    setSuccess(true);
    setTimeout(() => {
      navigate("/", {
        replace: true,
        state: { flash: t("checkout_completed_successfully") },
      });
      setTimeout(() => {
        deleteActiveCart();
      }, 50);
    }, 1000);
  };

  const onCheckoutFail = () => {
    setPaymentUrl(null);
    setPaymentFailed(true);
    setTimeout(() => {
      setPaymentFailed(false);
    }, 1000);
    toast.error(t("checkout_failed"), {
      position: "bottom-right",
    });
  };

  const onSubmit = async (data: any) => {
    setLoading(true);

    const response = await axios.post(
      "https://kaman.rest/api/auth/checkout",
      {
        menu: cartItems.map((cartItem) => ({
          item_id: cartItem.item.id,
          quantity: cartItem.quantity,
          item_options: {
            ingredients: cartItem.ingredients.map((ingredient) => ({
              id: ingredient.id,
            })),
          },
        })),
        order_method: data.orderType,
        payment_method: data.paymentMethod,
        customer_id: customerId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setLoading(false);

    if (!response.data.success) {
      toast.error(response.data.message);
      return;
    }

    if (response.data.data.order_url) {
      setPaymentUrl(response.data.data.order_url);
    } else {
      onCheckoutSuccess();
    }
  };

  const paymentMethods = [
    {
      id: "visa",
      name: t("payment.credit_card"),
      icon: CreditCard,
      description: t("payment.credit_card_desc"),
    },
    {
      id: "cash",
      name: t("payment.cash"),
      icon: Wallet,
      description: t("payment.cash_desc"),
    },
  ];

  const orderTypes: any[] = [
    {
      id: "eat_here",
      name: t("order.dine_in") || "Dine In",
      icon: Store,
      description: t("order.dine_in_desc") || "Eat at the restaurant",
      color: "blue",
    },
    {
      id: "take_away",
      name: t("order.pickup") || "Pickup",
      icon: Package,
      description: t("order.pickup_desc") || "Pick up your order",
      color: "blue",
    },
    {
      id: "delivery",
      name: t("order.delivery") || "Delivery",
      icon: Truck,
      description: t("order.delivery_desc") || "Deliver to your address",
      color: "blue",
    },
  ];

  if (paymentUrl) {
    return (
      <VisaPaymentForm
        url={paymentUrl}
        onSuccess={onCheckoutSuccess}
        onFail={onCheckoutFail}
      />
    );
  }

  return (
    <div className=" bg-gray-50 flex lg:p-8 flex-col lg:flex-row gap-6 lg:gap-8 justify-center">
      <div className="h-full bg-white rounded-xl border border-gray-200 shadow-lg p-4 lg:p-8 flex-1 lg:max-w-3xl">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="h-full flex flex-col"
        >
          <div className="flex-1 overflow-y-auto flex flex-col gap-6">
            <h1 className="text-3xl font-bold mb-2 text-center text-gray-900">
              {t("checkout")}
            </h1>

            <div
              className={`rounded-2xl p-6 lg:p-8 transition-all duration-200 ${
                errors.orderType
                  ? "border-2 border-red-300 bg-red-50 shadow-lg"
                  : "bg-white border-2 border-gray-100 shadow-md hover:shadow-lg"
              }`}
            >
              <h3 className="text-xl font-semibold text-gray-900 mb-6 flex items-center">
                {t("order_type")}
              </h3>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                {orderTypes.map((orderType: any) => {
                  const selected = watch("orderType") === orderType.id;
                  return (
                    <label
                      key={orderType.id}
                      className={`p-5 border-2 rounded-2xl transition-all duration-300 cursor-pointer group hover:scale-[1.02] ${
                        selected
                          ? `border-primary bg-primary-light shadow-lg transform scale-[1.02]`
                          : " border-gray-200 hover:border-gray-300 bg-white hover:shadow-md"
                      }`}
                    >
                      <input
                        type="radio"
                        value={orderType.id}
                        {...register("orderType", {
                          required: t("please_select_an_order_type"),
                        })}
                        className="hidden"
                      />
                      <div className="flex flex-col gap-2 items-start">
                        <div className="flex flex-row gap-4 items-center">
                          <div className="p-3 rounded-xl bg-primary-light text-primary group-hover:scale-110 transition-transform duration-200">
                            <orderType.icon className="w-5 h-5 text-primary" />
                          </div>
                          <p className="font-semibold text-gray-900 text-lg">
                            {orderType.name}
                          </p>
                          {/* {selected && (
                            <Check
                              className={`w-6 h-6 text-primary mt-1 animate-in zoom-in-50 duration-200`}
                            />
                          )} */}
                        </div>
                        <p className="text-sm text-gray-600 leading-relaxed">
                          {orderType.description}
                        </p>
                      </div>

                      {/* <div
                          className={`p-3 rounded-xl me-4 bg-primary-light text-primary group-hover:scale-110 transition-transform duration-200`}
                        >
                          <orderType.icon className="w-5 h-5" />
                        </div>
                        <div className="flex-1">
                          <div className="font-semibold text-gray-900 text-lg mb-1">
                            {orderType.name}
                          </div>
                          <div className="text-sm text-gray-600 leading-relaxed">
                            {orderType.description}
                          </div>
                        </div>
                        {selected && (
                          <Check
                            className={`w-6 h-6 text-primary mt-1 animate-in zoom-in-50 duration-200`}
                          />
                        )}
                      </div> */}
                    </label>
                  );
                })}
              </div>
              {errors.orderType && (
                <p className="text-red-600 text-sm font-medium mt-2 flex items-center">
                  <X className="w-4 h-4 mr-1" />
                  {errors.orderType.message as string}
                </p>
              )}
            </div>

            <div
              className={`rounded-2xl p-6 lg:p-8 transition-all duration-200 ${
                errors.paymentMethod
                  ? "border-2 border-red-300 bg-red-50 shadow-lg"
                  : "bg-white border-2 border-gray-100 shadow-md hover:shadow-lg"
              }`}
            >
              <h3 className="text-xl font-semibold text-gray-900 mb-6 flex items-center">
                {t("payment_method")}
              </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                {paymentMethods.map((paymentMethod: any) => {
                  const selected = watch("paymentMethod") === paymentMethod.id;
                  return (
                    <label
                      key={paymentMethod.id}
                      className={`p-5 border-2 rounded-2xl transition-all duration-300 cursor-pointer group hover:scale-[1.02] ${
                        selected
                          ? `border-primary bg-primary-light shadow-lg transform scale-[1.02]`
                          : " border-gray-200 hover:border-gray-300 bg-white hover:shadow-md"
                      }`}
                    >
                      <input
                        type="radio"
                        value={paymentMethod.id}
                        {...register("paymentMethod", {
                          required: t("please_select_a_payment_method"),
                        })}
                        className="hidden"
                      />
                      <div className="flex flex-col gap-2 items-start">
                        <div className="flex flex-row gap-4 items-center">
                          <div className="p-3 rounded-xl bg-primary-light text-primary group-hover:scale-110 transition-transform duration-200">
                            <paymentMethod.icon className="w-5 h-5 text-primary" />
                          </div>
                          <p className="font-semibold text-gray-900 text-lg">
                            {paymentMethod.name}
                          </p>
                          {/* {selected && (
                            <Check
                              className={`w-6 h-6 text-primary mt-1 animate-in zoom-in-50 duration-200`}
                            />
                          )} */}
                        </div>
                        <p className="text-sm text-gray-600 leading-relaxed">
                          {paymentMethod.description}
                        </p>
                      </div>
                    </label>
                  );
                })}
              </div>
              {errors.paymentMethod && (
                <p className="text-red-600 text-sm font-medium mt-2 flex items-center">
                  <X className="w-4 h-4 mr-1" />
                  {errors.paymentMethod.message as string}
                </p>
              )}
            </div>

            <button
              type="submit"
              disabled={false}
              className={`cursor-pointer mt-auto w-full disabled:from-gray-400 disabled:to-gray-500 text-white font-bold py-5 px-8 rounded-2xl transition-all duration-300 transform  shadow-xl hover:shadow-2xl flex items-center justify-center text-lg ${
                success
                  ? "bg-green-500"
                  : paymentFailed
                  ? "bg-red-500"
                  : "bg-primary hover:bg-primary/90"
              }`}
            >
              {loading && (
                <Loader2 className="h-8 w-8 animate-spin text-white" />
              )}
              {paymentFailed && <X className="h-8 w-8 text-white" />}
              {success && <Check className="h-8 w-8 text-white" />}
              {!loading && !success && !paymentFailed && t("complete_order")}
            </button>
          </div>
        </form>
      </div>

      <div className="flex-1 flex flex-col gap-6 lg:max-w-lg">
        <div className="bg-white rounded-2xl p-4 md:p-6 lg:p-8 flex flex-col gap-6 border-2 border-gray-100 shadow-lg">
          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900">
              {t("order_summary")}
            </h2>
            <span className="bg-primary sm:ml-auto py-2 px-4 text-white font-semibold rounded-xl shadow-md w-fit">
              {cartItems.length}{" "}
              {cartItems.length === 1 ? t("item") : t("items")}
            </span>
          </div>

          <div className="flex flex-col gap-5 max-h-96 overflow-y-auto">
            {cartItems.map((cartItem, index) => (
              <div
                key={index}
                className="flex flex-row gap-4 items-center p-3 bg-gray-50 rounded-xl border border-gray-100 hover:shadow-md transition-all duration-200"
              >
                <span className="bg-primary rounded-full h-10 w-10 flex items-center justify-center text-white font-bold text-lg shadow-md">
                  {cartItem.quantity}
                </span>
                <span className="text-2xl text-gray-400 font-light">×</span>
                <img
                  src={cartItem.item.image || mealPlaceholder}
                  className="w-16 h-16 object-cover rounded-xl border border-gray-200 shadow-sm"
                  alt={cartItem.item.name}
                />
                <div className="flex flex-col flex-1">
                  <h3 className="font-semibold text-gray-900 text-lg">
                    {cartItem.item.name}
                  </h3>
                  {cartItem.ingredients.length > 0 && (
                    <p className="text-gray-500 text-sm leading-relaxed">
                      {cartItem.ingredients
                        .map((ingredient) => ingredient.name)
                        .join(", ")}
                    </p>
                  )}
                </div>
                <span className="text-primary font-bold text-lg whitespace-nowrap">
                  ₪
                  {(cartItem.item.price +
                    cartItem.ingredients.reduce(
                      (acc, ing) => acc + ing.price,
                      0
                    )) *
                    cartItem.quantity}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-2xl p-6 lg:p-8 flex flex-row border-2 border-gray-100 shadow-lg items-center">
          <h2 className="text-2xl font-bold text-gray-900">{t("total")}</h2>
          <span className="bg-primary font-bold ms-auto text-white text-xl rounded-xl py-3 px-6 shadow-lg">
            ₪{totalPrice}
          </span>
        </div>
      </div>
    </div>
  );
}
